import React from "react";
import { useNavigate } from "react-router-dom";
import { Zap, ChevronRight } from "lucide-react";
import { Header } from "../../components/layout/Header";
import { Card } from "../../components/common/Card";

interface ToolItem {
  label: string;
  description: string;
  path: string;
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
}

const TOOLS: ToolItem[] = [
  {
    label: "Generate Parimutuel Event",
    description: "Create an event + betting board with randomized bets",
    path: "/dev/generate-parimutuel",
    icon: <Zap size={18} />,
    iconBg: "bg-amber-100",
    iconColor: "text-amber-600",
  },
];

export default function DevPage() {
  const navigate = useNavigate();

  return (
    <>
      <Header title='Dev Tools' showBack />
      <div className='px-4 py-4 space-y-4'>
        {/* Warning banner */}
        <div className='bg-amber-50 border border-amber-200 rounded-2xl px-4 py-3'>
          <p className='text-xs text-amber-700 font-semibold'>
            ⚠️ Development only
          </p>
          <p className='text-xs text-amber-600 mt-0.5'>
            These tools create real data in Firestore. Remove this page before
            going to production.
          </p>
        </div>

        {/* Tool list */}
        {TOOLS.map((tool) => (
          <Card key={tool.path} onClick={() => navigate(tool.path)}>
            <div className='flex items-center gap-3'>
              <div
                className={`w-9 h-9 rounded-xl ${tool.iconBg} flex items-center justify-center ${tool.iconColor}`}
              >
                {tool.icon}
              </div>
              <div className='flex-1 min-w-0'>
                <p className='font-semibold text-primary-800'>{tool.label}</p>
                <p className='text-xs text-gray-400 truncate'>
                  {tool.description}
                </p>
              </div>
              <ChevronRight size={16} className='text-gray-300 shrink-0' />
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}
